import styled from 'styled-components';
import { TEAL_200, TEAL_300 } from '../../../theme';

export default styled.div`
  ${({ isActive }) => (isActive ? `background-color: ${TEAL_300}` : '')}
  &:hover {
    background-color: ${({ isActive }) => (isActive ? TEAL_300 : TEAL_200)};
  }
`;
